import { render, staticRenderFns } from "./PopUpCreation.vue?vue&type=template&id=788c611a&scoped=true"
import script from "./PopUpCreation.vue?vue&type=script&lang=js"
export * from "./PopUpCreation.vue?vue&type=script&lang=js"
import style0 from "./PopUpCreation.vue?vue&type=style&index=0&id=788c611a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c611a",
  null
  
)

export default component.exports